export default __webpack_public_path__ + "static/media/bootstrap.bd712487.jpg";